import React, { useState } from 'react';
import { customStringify, error_alert, getAuthUser, getToken, setToken, success_alert } from '../../utils';
import useApi from '../../hooks/useApi';
import axios from 'axios';
import { network_tl } from '../../translations';
import { FormattedMessage, useIntl } from 'react-intl';
import { BiLoaderAlt } from 'react-icons/bi';
import { login } from '../../redux/slices/userSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Card = ({ data }) => {
    const { Axios } = useApi();
    const [loading, setLoading] = useState(false);
    const intl = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const featureData = {
        free_plan: [
            { id: "feature_influencers_free", defaultMessage: "Access to <strong>100</strong> influencers" },
            { id: "feature_campaigns_free", defaultMessage: "Cannot create campaigns" },
            { id: "feature_trial", defaultMessage: "30-day trial" },
        ],
        prod_Ri7fXzFO29WYpd: [
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
        ],
        prod_RfyKo00d9gA6gh: [
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
        ],
        prod_Ri7g5GR5I1e5zM: [
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
            { id: "feature_cancel", defaultMessage: "Cancel anytime" },
        ],
        prod_RfrpdBKAz7qND1: [
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
            { id: "feature_cancel", defaultMessage: "Cancel anytime" },

        ],
        prod_RfrsfFraf0K0uo: [
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
            { id: "feature_cancel", defaultMessage: "Cancel anytime" },
        ],

        prod_Ri7fKE3kvtvcfI: [
            { id: "feature_savings", defaultMessage: "<strong>Save €12</strong> compared to monthly (a 10% discount)" },
            { id: "feature_influencers", defaultMessage: "Access to <strong>6,500+</strong> influencers" },
            { id: "feature_campaigns", defaultMessage: "Unlimited campaign creation" },
            { id: "feature_dashboard", defaultMessage: "Advanced dashboard to manage multiple influencers" },
            { id: "feature_cancel", defaultMessage: "Cancel anytime" },
        ],
    };

    // const features = data.id === 'free_plan' ? featureData[data.id] : data.description.split('\n');
    const features = data.id === 'free_plan' ? featureData[data.id]    : data?.metadata?.description ? data?.metadata?.description?.split('\\n')
    ?.map(line => ({ 
        html: line.trim()
    })) : "";
            console.log(features, "features")

    const handlePlan = async () => {

        try {
            setLoading(true);
            if (data.id === 'free_plan') {
                const result = await Axios.patch(`api/user/freepackage`);
                const access_token = getToken();
                const authUser = getAuthUser();

                // token to save to local storage
                const tokenObj = {
                    user: {
                        ...authUser,
                        free_subscription: result.data.payload
                    },
                    access_token: access_token,
                };
                //saved to local storage
                setToken(tokenObj);

                // // set redux state
                dispatch(login({
                    ...authUser,
                    free_subscription: result.data.payload
                }));
                success_alert(result?.data?.description);
                navigate("/");
            } else {
                const result = await Axios.post(`api/user/subscription-checkout`, { plan_id: data.id });
                window.location.href = result.data.payload.url
            }

            setLoading(false);
            // success_alert(result.data.description);
        } catch (e) {
            if (axios.isCancel(e)) {

            } else if (e.response) {
                error_alert(customStringify(e.response.data.description))
                setLoading(false)
            } else {
                error_alert(network_tl(intl))
                setLoading(false)
            }
        }
    }
    return (
        <div className="relative flex flex-col rounded-xl transition-all duration-200 cursor-pointer 
            hover:scale-[1.02] bg-white shadow-md p-8 my-3 border border-slate-200 overflow-hidden">

            {/* Popular Tag */}
            <p className="capitalize font-semibold text-3xl text-slate-500 flex items-start">
                {data.name}
                {data.popular && (
                    <sup className='text-xs ml-2 text-white bg-primary rounded-full py-1 px-2'>
                        <FormattedMessage id="popular" defaultMessage={"Popular"} />
                    </sup>
                )}
            </p>

            {/* Card Header */}


            {/* Features List */}
            <ul className="flex flex-col h-full items-start justify-center flex-grow gap-4 mt-6">
            {features?.length > 0 && features?.map((feature, index) => (
                    <li key={index} className="flex items-center gap-4">
                        <span className="p-2 border rounded-full border-slate-200 bg-slate-50">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-5 h-5 text-slate-600"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </span>
                        <div className="text-slate-500">
                            {data.id === 'free_plan' ? (
                                <FormattedMessage 
                                    id={feature.id} 
                                    defaultMessage={feature.defaultMessage} 
                                    values={{ strong: (chunks) => <strong>{chunks}</strong> }} 
                                />
                            ) : (
                                <span dangerouslySetInnerHTML={{ __html: feature.html }} />
                            )}
                        </div>
                    </li>
                ))}
            </ul>

            <div className=" items-center text-slate-800">
                <p className="text-sm uppercase font-semibold text-slate-500">

                </p>
                <h1 className="flex justify-start h-full items-end gap-1  font-bold text-slate-800 text-5xl">
                    {data.no_price ? (
                        <span className="text-xl"><FormattedMessage id="custom_pricing" defaultMessage={"Custom pricing"} /></span>
                    ) : (
                        <div className='flex flex-col items-center justify-end gap-y-4 h-full w-full'>
                            <div className='flex flex-col py-4'>
                                <div className='flex text-center w-full'>
                                    <span className="text-2xl">€</span>
                                    <span className='text-5xl '>{data.price}</span>
                                    <sub className="self-end font-light text-xs text-slate-500 "><FormattedMessage id="only" defaultMessage={"Only"} /></sub>

                                    {/* <span className="self-end text-xl">/month</span> */}
                                </div>
                                {/* <p className='text-sm mb-2'>with a 1-year term</p> */}

                            </div>
                            <button disabled={loading} onClick={handlePlan} className="w-full py-3 text-base text-white font-medium bg-primary rounded-lg transition hover:bg-opacity-90">
                                {
                                    loading ?
                                        <BiLoaderAlt className="animate-spin text-white text-xl mx-auto" />
                                        :
                                        <FormattedMessage id="buy_now" defaultMessage={"Buy Now"} />
                                }
                            </button>
                        </div>
                    )}
                </h1>



            </div>

        </div>
    );
};

export default Card;
